import React, { useState, useEffect } from "react";
import pic_weixin from "./weixin.png";
import pic_app_ios from "./app_ios.png";
import pic_app_android from "./app_android.png";
import pic_gongzhonghao from "./gongzhonghao.png";
import pic_xhs from "./xhs.png";
import pic_xiaochengxu from "./xiaochengxu.png";
import styles from "./page1.scss";
import axios from "axios";
import { getRem } from "../../func";

function Page1() {
  const [status, setStatus] = useState("default");
  const [hover, setHover] = useState(null);
  const [jobInfo, setJobInfo] = useState("");
  const [numbers, setNumbers] = useState([]);

  useEffect(() => {
    axios
      .get("https://statics.wow-trend.com/static/numbers.json")
      .then((res) => res.data && setNumbers(res.data));

    axios
      .get("https://statics.wow-trend.com/wow-trend-cn/json/job_info.json")
      .then((res) => {
        setJobInfo(res.data);

        setTimeout(() => {
          const ele = document.getElementById("post-main");
          const child = ele.childNodes[0];
          const scrollBar = document.getElementById("scrollBar");
          const bar = scrollBar.childNodes[0];
          const maxTop = scrollBar.offsetHeight - bar.offsetHeight;

          ele.addEventListener("scroll", () => {
            bar.style.top = `${
              (maxTop * ele.scrollTop) / (child.offsetHeight - ele.offsetHeight)
            }px`;
          });

          window.addEventListener("mousemove", (e) => {
            if (!window.startPos) return;

            const pageY = e.pageY;

            const prevTop = parseFloat(getComputedStyle(bar)["top"]);
            let newTop = prevTop + 2 * (pageY - window.startPos.y);
            if (newTop > maxTop) {
              newTop = maxTop;
            } else if (newTop < 0) {
              newTop = 0;
            }
            // bar.style.top = `${newTop}px`;
            ele.scrollTop = `${
              (newTop / maxTop) * (child.offsetHeight - ele.offsetHeight)
            }`;

            window.startPos = { y: pageY };
          });

          window.addEventListener("mouseup", () => {
            window.startPos = null;
          });
        }, 300);
      });
  }, []);

  const renderLeftContent = () => {
    return (
      <>
        <div
          className={`${styles["page1-center-left-content1"]} ${
            status === "default" ? styles.show : styles.hide
          }`}
        >
          <div>
            业务咨询：各地销售经理&nbsp;
            <span
              className={styles["special"]}
              onClick={() => setStatus("contact")}
            >
              联系方式
            </span>
          </div>
          <div>
            加入我们：
            <span
              className={styles["special"]}
              onClick={() => setStatus("post")}
            >
              岗位招聘
            </span>
          </div>
          <div>
            电话：0755-88300156&nbsp;&nbsp;/&nbsp;&nbsp;4000610662
            <br />
            客服微信号：WOW-TREND728
            <br />
            网址：www.wow-trend.com
            <br />
            地址：广东省深圳市福田区车公庙创新一期A座1604
            <br />
          </div>
        </div>

        <div
          className={`${styles["page1-center-left-content2"]} ${
            status === "contact" ? styles.show : styles.hide
          }`}
        >
          <div
            className={styles["return"]}
            onClick={() => setStatus("default")}
          >
            <i className="iconfont iconsousuojieguo_fanhui" />
          </div>

          <div className={styles["contacts-wrapper"]}>
            {numbers.map((item, index) => {
              return (
                <div
                  key={item}
                  className={`${styles["contact-item"]} ${
                    index % 2 ? styles["right"] : styles["left"]
                  }`}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </div>

        <div
          className={`${styles["page1-center-left-content3"]} ${
            status === "post" ? styles.show : styles.hide
          }`}
        >
          <div
            className={styles["return2"]}
            onClick={() => setStatus("default")}
          >
            <i className="iconfont iconsousuojieguo_fanhui" />
          </div>

          <div id="post-main" className={styles["post-main"]}>
            <div
              style={{ display: "inline-block" }}
              dangerouslySetInnerHTML={{ __html: jobInfo }}
            ></div>
          </div>

          <div className={styles.bottom}>
            简历及作品统一发至: hr@wow-trend.com
          </div>

          <div id="scrollBar" className={styles.scrollBar}>
            <div
              style={{ top: "" }}
              className={styles.bar}
              onMouseDown={(e) => {
                window.startPos = {
                  y: e.pageY,
                };
              }}
            />
          </div>
        </div>
      </>
    );
  };

  const renderRightContent = () => {
    return (
      <>
        <span
          className={`${styles.text} ${!hover ? styles.show : styles.hide}`}
        >
          WOW -TREND SHARING WHAT’S NEXT！
        </span>

        <div
          className={`${styles.imgWrap} ${
            hover === "weixin" ? styles.show : styles.hide
          }`}
        >
          <img
            alt=""
            src={pic_weixin}
            style={{ width: getRem(185), height: getRem(185) }}
          />

          <div className={styles.text} style={{ width: getRem(185) }}>
            扫码添加客服微信
          </div>
        </div>

        <div
          className={`${styles.imgWrap} ${styles.imgWrap2} ${
            hover == "app" ? styles.show : styles.hide
          }`}
        >
          <div className={styles.item}>
            <img alt="" src={pic_app_ios} />

            <div className={styles.text} style={{ width: getRem(185) }}>
              App Store 下载
            </div>
          </div>

          <div className={styles.item}>
            <img alt="" src={pic_app_android} />

            <div className={styles.text} style={{ width: getRem(185) }}>
              Android 下载
            </div>
          </div>
        </div>

        <div
          className={`${styles.imgWrap} ${
            hover === "gongzhonghao" ? styles.show : styles.hide
          }`}
        >
          <img alt="" src={pic_gongzhonghao} style={{ width: getRem(220) }} />
        </div>

        <div
          className={`${styles.imgWrap} ${
            hover === "xhs" ? styles.show : styles.hide
          }`}
        >
          <img alt="" src={pic_xhs} style={{ width: getRem(220) }} />
        </div>
      </>
    );
  };

  return (
    <div className={styles["page1"]}>
      <div className={styles["page1-main"]}>
        <div className={styles["page1-title"]}>CONTACT US</div>

        <div className={styles["page1-subTitle"]}>联系我们</div>

        <div className={styles["page1-center"]}>
          <div className={styles["page1-center-left"]}>
            {renderLeftContent()}
          </div>

          <div className={styles["page1-center-right"]}>
            {renderRightContent()}
          </div>
        </div>

        <div className={styles["page1-icons"]}>
          <div
            className={styles["page1-icon"]}
            onMouseEnter={() => setHover("weixin")}
            onMouseLeave={() => setHover(null)}
          >
            <i className="iconfont iconweixin2" />

            <div>热点趋势官方客服</div>
          </div>

          <div
            className={styles["page1-icon"]}
            onMouseEnter={() => setHover("app")}
            onMouseLeave={() => setHover(null)}
          >
            <i className="iconfont iconbianzu1" />

            <div>热点趋势手机端</div>
          </div>

          <div
            className={styles["page1-icon"]}
            onMouseEnter={() => setHover("gongzhonghao")}
            onMouseLeave={() => setHover(null)}
          >
            <i className="iconfont iconbianzu1" />

            <div>公众号（热点趋势）</div>
          </div>

          <div
            className={styles["page1-icon"]}
            // onClick={() => window.open("https://www.instagram.com/?hl=zh-cn")}
            onMouseEnter={() => setHover("xhs")}
            onMouseLeave={() => setHover(null)}
          >
            <i className="iconfont iconxiaohongshu" />

            <div>小红书（热点趋势）</div>
          </div>
        </div>

        <div className={styles["page1-beian"]}>粤ICP备15020968号</div>
      </div>
    </div>
  );
}

export default Page1;
